"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FolderUserSolid: function() {
        return FolderUserSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FolderUserSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 3C2.34315 3 1 4.34315 1 6V18C1 19.6569 2.34315 21 4 21H20C21.6569 21 23 19.6569 23 18V8C23 6.34315 21.6569 5 20 5H12.6056C12.4081 5 12.2151 4.94156 12.0509 4.83205L10.0585 3.50385C9.56575 3.17531 8.98672 3 8.39445 3H4ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM16.9765 18.7843C16.9921 18.8551 17 18.9274 17 19C13.3919 19 10.6081 19 7 19C7 18.9274 7.0079 18.8551 7.02355 18.7843C7.51281 16.5698 9.60347 15 12 15C14.3965 15 16.4872 16.5698 16.9765 18.7843Z",
        fill: "currentColor"
    })
}), "FolderUserSolid");
const _default = FolderUserSolid;
